import React from "react";
import {
  FiHeart,
  FiUsers,
  FiCheckCircle,
  FiShield,
  FiSmile,
  FiStar,
  FiTrendingUp,
  FiGlobe,
  FiPhoneCall,
  FiZap,
} from "react-icons/fi";

function Info() {
  return (
    <section className="info-section">
      <div className="container info-container">
        {/* About Platform */}
        <div className="info-card">
          <div className="info-top-icon">
            <FiHeart />
          </div>
          <h3 className="info-heading">About Our Platform</h3>
          <p className="info-text">
            We are a next-generation matchmaking platform that blends emotional intelligence with modern technology. 
            Our mission is to help individuals find real, lasting relationships built on compatibility and mutual trust.
          </p>
          <p className="info-text">
            With a focus on transparency, personalization, and community, we go beyond profiles — creating meaningful connections for everyone.
          </p>
        </div>

        {/* Key Features */}
        <div className="info-card">
          <div className="info-top-icon">
            <FiCheckCircle />
          </div>
          <h3 className="info-heading">Key Features</h3>
          <ul className="info-list">
            <li><FiUsers className="info-icon" /> Verified & Genuine Profiles</li>
            <li><FiSmile className="info-icon" /> Smart Compatibility Algorithm</li>
            <li><FiShield className="info-icon" /> Advanced Security & Privacy</li>
            <li><FiHeart className="info-icon" /> 24/7 Match Support & Guidance</li>
          </ul>
        </div>

        {/* Why Choose Us */}
        <div className="info-card">
          <div className="info-top-icon">
            <FiStar />
          </div>
          <h3 className="info-heading">Why Choose Us</h3>
          <ul className="info-list">
            <li><FiSmile className="info-icon" /> Beautiful, Easy-to-Use Interface</li>
            <li><FiHeart className="info-icon" /> Thousands of Success Stories</li>
            <li><FiUsers className="info-icon" /> Vibrant, Supportive Community</li>
            <li><FiShield className="info-icon" /> Trusted by 10K+ Verified Members</li>
          </ul>
        </div>

        {/* Global Reach */}
        <div className="info-card">
          <div className="info-top-icon">
            <FiGlobe />
          </div>
          <h3 className="info-heading">Global Reach</h3>
          <p className="info-text">
            Connect with members from across the world who share your language, culture, or lifestyle. 
            Our platform supports international matchmaking with location-based search and translation support.
          </p>
          <ul className="info-list">
            <li><FiTrendingUp className="info-icon" /> 30+ Countries Connected</li>
            <li><FiGlobe className="info-icon" /> Multi-language Support</li>
          </ul>
        </div>

        {/* Mobile App */}
        <div className="info-card">
          <div className="info-top-icon">
            <FiZap />
          </div>
          <h3 className="info-heading">Available Anytime, Anywhere</h3>
          <p className="info-text">
            Enjoy the full experience on mobile. Stay connected, receive real-time notifications, 
            and chat instantly with your matches — all from the comfort of your phone.
          </p>
          <ul className="info-list">
            <li><FiStar className="info-icon" /> Android & iOS App</li>
            <li><FiHeart className="info-icon" /> Instant Notifications & Chat</li>
          </ul>
        </div>

        {/* Support */}
        <div className="info-card">
          <div className="info-top-icon">
            <FiPhoneCall />
          </div>
          <h3 className="info-heading">24/7 Member Support</h3>
          <p className="info-text">
            Our dedicated support team is always ready to assist. Whether you need help setting up your profile, 
            or want relationship guidance, we’re just a message away.
          </p>
          <ul className="info-list">
            <li><FiCheckCircle className="info-icon" /> In-App Chat Support</li>
            <li><FiShield className="info-icon" /> Privacy & Safety Assistance</li>
            <li><FiSmile className="info-icon" /> Personal Guidance Available</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Info;
